/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ generated: NonNullable<unknown>, cached: NonNullable<unknown> }} Pre_Render_Frame_Cache_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Frame cache ready ({generated} generated, {cached} already cached)" |
*
* @param {Pre_Render_Frame_Cache_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_complete_toast = /** @type {((inputs: Pre_Render_Frame_Cache_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cache d'images prêt (${i?.generated} générées, ${i?.cached} déjà en cache)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Frame-Cache bereit (${i?.generated} generiert, ${i?.cached} bereits im Cache)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Cache dei frame pronta (${i?.generated} generato, ${i?.cached} già memorizzato nella cache)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Кэш кадров готов (${i?.generated} сгенерирован, ${i?.cached} уже кэширован)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Caché de fotogramas lista (${i?.generated} generados, ${i?.cached} ya en caché)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`帧缓存已就绪（${i?.generated} 已生成，${i?.cached} 已缓存）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームキャッシュ準備完了（${i?.generated}生成済み、${i?.cached}は既にキャッシュ済み）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ्रेम कैश तैयार है (${i?.generated} जनरेट हो गया है, ${i?.cached} पहले से ही कैश में मौजूद है)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Cache de quadros pronto (${i?.generated} gerado, ${i?.cached} já em cache)`)
	return /** @type {LocalizedString} */ (`Frame cache ready (${i?.generated} generated, ${i?.cached} already cached)`)
});